import React, {Component} from 'react';
import $ from 'jquery';
import {
    AJAX,
    showPreloader,
    show_success_popup,
    hidePreloader,
    show_popup,
    close_popup,
    cross_form_errors,
    compressImage,
    addStepLog,
    setUrlSinglePageApp
} from "../functions";
import {Redirect} from "react-router-dom";
import {Route, Router, withRouter} from "react-router";
import {showProgressBarPopup} from "../popups/ProgressBarPopup";
import RedirectOnlyHome from "../common/RedirectOnlyHome";
import PreviewPhoto from "../common/PreviewPhoto";
import {showPopupWithGoBack} from "../popups/PopupWithGoBack";
import {showPopupNoteArticle} from "../popups/PopupNoteArticle";
import WrapperContentFromArticleForPopup from "../common/WrapperContentFromArticleForPopup";


class ReturnPopupActions extends Component {
	constructor(props) {
		super(props);
		this.sendAnswer = this.sendAnswer.bind(this);
        this.state = {
            hideGoNext: !!this.props.hideGoNext,
        };
	}

	sendAnswer(options) {
		this.props.sendAnswer(options);
	}

	proceed() {
		close_popup();
		this.sendAnswer();
	}

	goBack() {
		close_popup();
	}

	render() {
		return (
			<div className="row">
				<div className="col-12 text-center">
					<div className="row m-3">
						<div className="col-12 text-center gray">
							{this.props.text}
						</div>
					</div>
					<div className="row mx-3 text-center mb-3">
						<div className={this.state.hideGoNext ? "col-12" :  "col-6"}>
                            <button type="button" className="go-btn go-back" onClick={this.goBack.bind(this)} />
						</div>
                        {
                            this.state.hideGoNext ? ('') : (
                                <div className="col-6 text-center">
                                    <button type="button" className="go-btn go-next" onClick={this.proceed.bind(this)}/>
                                </div>
                            )
                        }

					</div>
				</div>
			</div>
		);
	}
}


/*const steps = {
    fuel: {next: 'cargo'},
    cargo: {next: 'accident'},
    accident: {next: 'damage'},
    damage: {next: 'complete'},
};*/

const steps = {
    1: 'fuel_return',
    2: 'cargo',
    3: 'accident',
    4: 'damage'
};

const questions = {
    1: 'Have you returned the vehicle with a full tank of fuel?',
    2: 'Have you removed all personal belongings and any left-over rubbish in the cargo area and passenger cabin?',
    3: 'Was the vehicle involved in an accident during your hire?',
    4: 'Has any new damage occurred to the vehicle during your hire?',
};

const photo_steps = {
    1: {max: 1, photos: ['fuel_return'], nameStackInState: 'stackFuelReturnPhoto'},
//    2: {max: 1, photos: ['cargo'], nameStackInState: 'stackCargoPhoto'},
    4: {max: 5, photos: ['damage1','damage2','damage3','damage4','damage5'], nameStackInState: 'stackDamagePhoto'}
};

const max_dmg_photo = 5;

class ReturnVehiclePage extends Component {
    constructor(props) {
        super(props);
        this.handleSetPage = this.handleSetPage.bind(this);
        this.allowSendPhoto = this.allowSendPhoto.bind(this);
        this.allowGoNext = this.allowGoNext.bind(this);
        this.handleClickYes = this.handleClickYes.bind(this);
        this.handleClickNo = this.handleClickNo.bind(this);
        this.handleGoNext = this.handleGoNext.bind(this);
        this.sendPhoto = this.sendPhoto.bind(this);
        this.sendFormByEmail = this.sendFormByEmail.bind(this);
        this.setAnswerInStep = this.setAnswerInStep.bind(this);
        this.syncAnswers = this.syncAnswers.bind(this);
        this.sendAnswer = this.sendAnswer.bind(this);
        this.sortDamagePhoto = this.sortDamagePhoto.bind(this);
        this.sortFuelReturnPhoto = this.sortFuelReturnPhoto.bind(this);
//        this.sortCargoPhoto = this.sortCargoPhoto.bind(this);
        this.displayPhotos = this.displayPhotos.bind(this);
        this.addPhoto = this.addPhoto.bind(this);
        this.goBackPrevStage = this.goBackPrevStage.bind(this);
        this.handleSetPage({name: 'return_vehicle', params: false});
        this.state = {
            send_photo: false,
            go_next: false,
            stage: 1,
            file_urls: {},
            redirect: false,
            answers:{},
            damage_comment:'',
            uploadPercent: 0,
            displayCommentAndUpladPhoto: false,
            photoStep: 0,
            stackFuelReturnPhoto: [],
//            stackCargoPhoto: [],
            stackDamagePhoto: [],
            currentMaxPhoto: 1,
        };
        if (Object.keys(steps).indexOf(this.props.match.params.step) !== -1) {
            this.state.stage = parseInt(this.props.match.params.step, 10);
        }
        this.syncAnswers(true);
        if(this.props.return_instr_note)
            showPopupNoteArticle(<WrapperContentFromArticleForPopup note={this.props.return_instr_note} />);
    }

    componentDidMount() {
        this.sortFuelReturnPhoto();
//        this.sortCargoPhoto();
        this.sortDamagePhoto();
        this.updateMaxPhotosByStack();

        this.unlisten = this.props.history.listen((location, action) => {
            if (location.pathname !== '/send_photo/lock/dashboard') {
                setUrlSinglePageApp(location.pathname);
            }
        });

        setUrlSinglePageApp(this.props.history.location.pathname);
    }

    componentWillUnmount() {
        this.unlisten();
    }

    updateMaxPhotosByStack() {
        if (Object.keys(photo_steps).indexOf(this.state.stage.toString()) !== -1) {
            let currPhSt = photo_steps[this.state.stage];
            let lStack = this.state[currPhSt.nameStackInState].length;
            let lMaxPhoto = currPhSt.photos.length;
            let currMax = 1;
            if (lStack > 0 && lStack <= lMaxPhoto) {
                currMax = lStack;
            } else if (lStack > lMaxPhoto) {
                currMax = lStack;
            }
            this.setState({currentMaxPhoto: currMax, photoStep: currMax-1})
        }
    }

    addPhoto(event) {
        event.preventDefault();
        let currMax = this.state.currentMaxPhoto;
        let lMaxPhoto = photo_steps[this.state.stage].photos.length;
        if (currMax < lMaxPhoto) {
            currMax++;
            this.setState({
                currentMaxPhoto: currMax,
                photoStep: currMax-1
            });
        }
    }

    componentDidUpdate(prevProps) {
        if (prevProps.match.params.step !== this.props.match.params.step) {
            this.setState({stage: parseInt(this.props.match.params.step, 10)});
            if (this.state.stage === 1 || /*this.state.stage === 2 ||*/ this.state.stage === 4) {
                // this.setState({photoStep: 0});
                this.updateMaxPhotosByStack();
            }
        }
    }

    handleSetPage(options) {
        if (options.name == 'return_vehicle')
            addStepLog('Return vehicle Page');
        this.props.handleSetPage(options);
    }

    allowSendPhoto() {
        this.setState({send_photo: true});
    }

    allowGoNext() {
        this.setState({go_next: true});
    }
    disallowGoNext() {
        this.setState({go_next: false});

    }

    syncAnswers(inConstruct) {
        let answers = {};
        for(let i in steps) {
            let curr_s = steps[i];
            if (this.props.booking_state.hasOwnProperty(curr_s)) {
                if (this.props.booking_state[curr_s])
                    answers[curr_s] = this.props.booking_state[curr_s];
                else
                    answers[curr_s] = null;
            }
        }

        let damage_comment = this.props.booking_state.damage_comment !== null ?
            this.props.booking_state.damage_comment : '';

        if (inConstruct === true) {
            this.state.answers = answers;
            this.state.damage_comment = damage_comment;
        } else
            this.setState({answers: answers, damage_comment: damage_comment});
    }

    sendFormByEmail() {
        let params = {
            session_key: this.props.session_key,
            form_type: 'accident',
            action: 'api/booking/send_form_by_email'
        };
        let t = this;
        AJAX(bm_ajax_url, 'POST', params, {
            response_json: true,
            func_waiting: function () {
                showPreloader();
            },
            func_callback: function (resp) {
                hidePreloader();
                if (resp.success === 1) {
                    show_success_popup('The form has been sent to you by email.');
                    setTimeout(()=>t.showAccidentFormPopup(), 2000);
                } else {
                    if (resp.errors && 'main' in resp.errors && Object.keys(resp.errors.main).length) {
                        showPopupWithGoBack(resp.errors.main);
                    }
                }
            },
            func_error: function (resp) {
                hidePreloader();
                showPopupWithGoBack(resp.message);
                setTimeout(()=>t.showAccidentFormPopup(), 2000);
            }
        });
    }

    setAnswerInStep(step, answer) {
        let list_current_answ = this.state.answers;
        list_current_answ[step] = answer;
        this.setState({answers:list_current_answ})
    }

    handleClickYes() {
        addStepLog('Press button YES on stage: '+ steps[this.state.stage]+' on Return vehicle page');
        let popup_text = '';
        switch (this.state.stage) {
            case 1:
                this.disallowGoNext();
                break;
            case 2:
                this.allowGoNext();
                break;
            case 3:
                this.showAccidentFormPopup();
                this.allowGoNext();
                break;
            case 4:
                this.allowSendPhoto();
                this.disallowGoNext();
                this.setState({displayCommentAndUpladPhoto: true});
                close_popup();
                show_popup(<ReturnPopupActions hideGoNext={true} sendAnswer={()=>{return false}} text={'Any vehicle that gains new damage during the course of a hire needs photos for our files.\r\nPlease submit photos of the damage now.'}/>, {auto_close: false});
                break;
        }
        this.setAnswerInStep(steps[this.state.stage], 'yes');

        /*if ([3].indexOf(this.state.stage) !== -1) {
            close_popup();
            show_popup(<ReturnPopupActions handleGoNext={this.handleGoNext} text={popup_text}/>, {auto_close: false});
        }*/
    }

    showAccidentFormPopup() {
        let popup_text = (
            <>
                As per the Rental Agreement you must report any accident to us within 24 hours of it occurring
                and fully completing the Accident report form within 48 hours and forwarding it to <a
                href="mailto:admin@gowiththegecko.com.au">admin@gowiththegecko.com.au</a>.
                <br/>
                Please <a className="blue-link" target="_blank"
                          href={init_plugin_dir + '../public/files/Hire-Fleet-Hirer-Collision-or-Damage-Report-Form.pdf'}>
                download the form</a> below for completing,
                or click <a className="blue-link" target="_blank"
                            onClick={event => {event.preventDefault();this.sendFormByEmail();}}>here</a> to
                email the form to your email address to complete later.
            </>
        );
        close_popup();
        show_popup(<ReturnPopupActions sendAnswer={this.sendAnswer} text={popup_text}/>, {auto_close: false});
    }

    handleClickNo() {
        addStepLog('Press button NO on stage: '+ steps[this.state.stage]+' on Return vehicle page');
        let popup_text;
        switch (this.state.stage) {
            case 1:
                popup_text = 'You will be charged for the cost of fuel used during your hire, plus a labour charge of $55 if you do not return the vehicle will a full tank of fuel.';
                this.allowGoNext();
                break;
            case 2:
                popup_text = 'Please note you will charged a cleaning/rubbish removal fee - if the vehicle is not returned in a clean and tidy condition, this includes removing any cargo or personal belongs left in the vehicle.';
                break;
            case 3:
            case 4:
                this.allowGoNext();
                this.setState({displayCommentAndUpladPhoto: false});
                break;
        }
        this.setAnswerInStep(steps[this.state.stage], 'no');

        if ([1,2].indexOf(this.state.stage) !== -1) {
            close_popup();
            show_popup(<ReturnPopupActions sendAnswer={this.sendAnswer} text={popup_text}/>, {auto_close: false});
        }
    }

    handleGoNext() {
        let stage = this.state.stage;
        if (stage < 4) {
            stage += 1;
            this.setState({stage: stage, send_photo: false, go_next: false});
            this.props.history.push('/return_vehicle/step/'+stage+'/');
        } else {
            this.handleSetPage({name: 'send_photo', params: {operation: 'lock'}});
            this.setState({redirect: true});
        }
    }

    sortFuelReturnPhoto() {
        let t = this;
        let files = t.props.booking_state.files.return_vehicle;
        let stackFuelReturnPhoto = t.state.stackFuelReturnPhoto;
        for(let i in files) {
            if (photo_steps["1"].photos.indexOf(i) !== -1) {
                let indexInStack = stackFuelReturnPhoto.indexOf(i);
                if (files[i]) {
                    if (indexInStack === -1)
                        stackFuelReturnPhoto.push(i);
                } else {
                    if (indexInStack !== -1) {
                        stackFuelReturnPhoto.splice(indexInStack, 1);
                    }
                }
            }
        }
        t.setState({stackFuelReturnPhoto: stackFuelReturnPhoto})
    }

/*    sortCargoPhoto() {
        let t = this;
        let files = t.props.booking_state.files.return_vehicle;
        let stackCargoPhoto = t.state.stackCargoPhoto;
        for(let i in files) {
            if (photo_steps["2"].photos.indexOf(i) !== -1) {
                let indexInStack = stackCargoPhoto.indexOf(i);
                if (files[i]) {
                    if (indexInStack === -1)
                        stackCargoPhoto.push(i);
                } else {
                    if (indexInStack !== -1) {
                        stackCargoPhoto.splice(indexInStack, 1);
                    }
                }
            }
        }
        t.setState({stackCargoPhoto: stackCargoPhoto})
    }*/

    sortDamagePhoto() {
        let t = this;
        let files = t.props.booking_state.files.return_vehicle;
        let stackDamage = t.state.stackDamagePhoto;
        for(let i in files) {
            if (photo_steps["4"].photos.indexOf(i) !== -1) {
                let indexInStack = stackDamage.indexOf(i);
                if (files[i]) {
                    if (indexInStack === -1)
                        stackDamage.push(i);
                } else {
                    if (indexInStack !== -1) {
                        stackDamage.splice(indexInStack, 1);
                    }
                }
            }
        }
        t.setState({stackDamagePhoto: stackDamage})
    }

    sendAnswer() {
        addStepLog('Press button goNext in stage: '+steps[this.state.stage]+' on Return vehicle Page');
        let t = this;

        if (t.goNextDisabled()) {
            return false;
        }

        let fields = ['damage_comment'];
        let form_inputs = $('.form-inputs');
        let params = {
            session_key: t.props.session_key,
            global_operation: t.props.global_operation,
            answer_key: steps[t.state.stage],
            answer_value: t.state.answers[steps[t.state.stage]],
            action: 'api/booking/send_answer'
        };

        if (params.answer_key === 'damage')
            params.damage_comment = t.state.damage_comment;

        AJAX(bm_ajax_url, 'POST', params, {
            response_json: true,
            func_waiting: showPreloader,
            func_callback: function (resp) {
                hidePreloader();
                if (resp.success === 1 && Object.keys(resp.data).length) {
                    t.props.handleSetBookingState(resp.data.booking_state);
                    t.syncAnswers();
                    t.handleGoNext();

                } else {
                    if (resp.errors && 'main' in resp.errors && Object.keys(resp.errors.main).length) {
                        showPopupWithGoBack(resp.errors.main);
                    }
                }
                cross_form_errors(resp.errors !== undefined && resp.errors.form !== undefined ? resp.errors.form : {}, fields, form_inputs);
            },
            func_error: function (resp) {
                hidePreloader();
                showPopupWithGoBack(resp.message);
            }
        });
    }

    sendPhoto(event, photo) {
        addStepLog('Send photo in stage: '+steps[this.state.stage]+' on Return vehicle Page');

        let t = this;
        let file = event.target.files[0];
        if (!file)
            return false;

        compressImage(
            file,
            (modifiedFile) => {
                let params = {
                    session_key: t.props.session_key,
                    resno: t.props.client_data.resno,
                    operation: 'return_vehicle',
                    global_operation: t.props.global_operation,
                    step: photo,
                    files: {
                        photo: modifiedFile
                    },
                    action: 'api/booking/send_photo'
                };

                AJAX(bm_ajax_url, 'POST', params, {
                    response_json: true,
                    func_waiting: ()=>showProgressBarPopup(t.state.uploadPercent),
                    func_callback: function (resp) {
                        close_popup();
                        if (resp.success === 1 && Object.keys(resp.data).length) {
                            t.props.handleSetBookingState(resp.data.booking_state);
                            t.sortFuelReturnPhoto();
//                            t.sortCargoPhoto();
                            t.sortDamagePhoto();

                            t.setState({uploadPercent: 0});
                            if (t.state.damage_comment) {
                                t.setState({
                                    go_next: true
                                });
                            }
                        } else {
                            if (resp.errors && 'main' in resp.errors && Object.keys(resp.errors.main).length) {
                                showPopupWithGoBack(resp.errors.main);
                            }
                        }
                    },
                    func_error: function (resp) {
                        close_popup();
                        showPopupWithGoBack(resp.message);
                    },
                    func_progress: function (evt) {
                        if (evt.lengthComputable) {
                            let percentComplete = Math.round(evt.loaded / evt.total * 100);
                            t.setState({uploadPercent: percentComplete}, () => showProgressBarPopup(t.state.uploadPercent));
                        }
                    }
                });
            }
        );
    }

    getPhoto(step) {
        if(
            this.props.booking_state.hasOwnProperty('files') &&
            this.props.booking_state.files.hasOwnProperty('return_vehicle')
        ) {
            if (step==='damage') {
                return this.props.booking_state.files.return_vehicle.damage1
            }
            return  this.props.booking_state.files.return_vehicle[step];
        }
        else
            return null;
    }

    getRealPhotos(step) {
        if(
            this.props.booking_state.hasOwnProperty('files') &&
            this.props.booking_state.files.hasOwnProperty('return_vehicle')
        ) {
            let photo = this.props.booking_state.files.return_vehicle[step];
            if (photo)
                return photo;
        }
        return null;
    }
    getNamePropertyPhoto() {
        let p = photo_steps[this.state.stage].photos;
        for (i in p) {
            let n_ph = this.getRealPhotos(p[i]);
            if (!n_ph)
                return p[i];
        }
        return null;
    }

    linkForDamagePhotoNavigation(i) {
        return <div>Damage&nbsp;<a className="blue-link" onClick={event => {event.preventDefault(); this.setState({photoStep: i});}}>photo {i+1}</a></div>;
    }

    removePhoto(currPhoto) {
        let params = {
            session_key: this.props.session_key,
            resno: this.props.client_data.resno,
            operation: 'return_vehicle',
            global_operation: this.props.global_operation,
            step: currPhoto,
            action: 'api/booking/remove_photo'
        };
        let t = this;

        AJAX(bm_ajax_url, 'POST', params, {
            response_json: true,
            func_waiting: showPreloader,
            func_callback: function (resp) {
                hidePreloader();
                if (resp.success === 1 && Object.keys(resp.data).length) {
                    t.props.handleSetBookingState(resp.data.booking_state);
                    if (t.state.currentMaxPhoto > 1) {
                        let updMax = t.state.currentMaxPhoto-1;
                        let updCurrStep = t.state.photoStep;
                        if (updCurrStep >= updMax)
                            updCurrStep = updMax - 1;

                        t.setState({currentMaxPhoto: updMax, photoStep: updCurrStep});
                    }
                    t.sortDamagePhoto();
                } else {
                    hidePreloader();
                    if (resp.errors && 'main' in resp.errors && Object.keys(resp.errors.main).length) {
                        showPopupWithGoBack(resp.errors.main);
                    }
                }
            },
            func_error: function (resp) {
                hidePreloader();
                showPopupWithGoBack(resp.message);
            },
        });
    }

    displayPhotos() {
        let preview_texts = {
            1: 'Receipt of fuel purchase',
//            2: 'Cargo Area',
            4: 'Damage occurred photo ',
        };


        let displayPhotos = [];

        let previews = [];

        let max_ph = this.state.currentMaxPhoto;
        /*if (this.state.stage === 4) {
            max_ph = this.state.currentMaxPhoto;
        }*/

        let phSteps = photo_steps[this.state.stage];
        let currentStack = this.state[phSteps.nameStackInState].slice();
        let currentStackWithEmpty = currentStack.slice();
        if (currentStackWithEmpty.length < phSteps.photos.length) {
            for (let i in phSteps.photos) {
                if (currentStackWithEmpty.indexOf(phSteps.photos[i]) === -1) {
                    currentStackWithEmpty.push(phSteps.photos[i]);
                }
            }
        }


        // let list_exsPhoto = this.getPhoto()


        for (let i = 0; i < max_ph; i++) {
            let currentPhoto = currentStackWithEmpty[i];
            let realPh = this.getRealPhotos(currentPhoto);
            previews.push(
                <div key={i}>
                    <div className={"photo-preview" + (this.state.photoStep === i ? ' current_step' : '')/* + ([1,2].indexOf(this.state.stage) !== -1 ? ' photo-preview-single' : '')*/}>
                        {
                            realPh ? (
                                // <img src={realPh} />
                                <PreviewPhoto src={realPh} />
                            ) : (
                                <div className="no-photo"/>
                            )
                        }
                        {
                            this.state.stage == 4 ?
                                this.linkForDamagePhotoNavigation(i)
                                : preview_texts[this.state.stage]
                        }
                        {
                            this.state.stage == 4 && realPh ? (
                                <div className="remove-photo" onClick={()=>this.removePhoto(currentPhoto)}>
                                    <div />
                                    <div />
                                </div>
                            ) : ('')
                        }
                    </div>
                    {
                        this.state.photoStep === i && this.state.currentMaxPhoto < phSteps.max && this.state.currentMaxPhoto === currentStack.length ? (
                            <div className="row">
                                <div className="col-12 text-center my-3">
                                    <a className="blue-link" onClick={this.addPhoto}>Add Photo</a>
                                </div>
                            </div>
                        ) : ('')
                    }
                    {
                        this.state.photoStep === i ? this.showTakePhotoButton(currentPhoto) : ('')
                    }
                </div>
            )
        }


        // for () {
        //
        // }


        return (<>
            <div className="row mb-3">
                <div className="col-12 mx-4 pl-4 pr-5 text-left">
                    {previews}
                </div>
            </div>
        </>)
    }

    classNameSelectedAnswer(current) {
        if (current === this.state.answers[steps[this.state.stage]])
            return ' selected';
        return '';
    }

    handleUserInput = (e) => {
        let name = e.target.name;
        let value = e.target.value;
        this.setState({[name]: value});
        if (this.state.stage === 4 && name === 'damage_comment' && value.length > 0 && this.state.file_urls[this.state.stage])
            this.allowGoNext();
        else
            this.disallowGoNext();
    };

    goNextDisabled() {
        let disable = true;
        switch (this.state.stage) {
            case 1:
                /*if (this.state.stackFuelReturnPhoto.length && this.state.answers[steps[this.state.stage]] === 'yes'
                    || this.state.answers[steps[this.state.stage]] === 'no') {
                    disable = false;
                }
                break;*/
                if (this.state.answers[steps[this.state.stage]] || this.state.go_next)
                    disable = false;
                break;
            case 2:
/*                if ((this.state.stackCargoPhoto.length && this.state.answers[steps[this.state.stage]] === 'yes')
                    || this.state.answers[steps[this.state.stage]] === 'no') {
                    disable = false;
                }
                break;*/
            case 3:
                if (this.state.answers[steps[this.state.stage]] || this.state.go_next)
                disable = false;
                break;
            case 4:
                if ((this.state.stackDamagePhoto.length
                    && this.state.answers[steps[this.state.stage]] === 'yes'
                    && this.state.damage_comment.length
                ) || this.state.answers[steps[this.state.stage]] === 'no') {
                    disable = false;
                }
                break;
        }
        return disable;
    }

    showCommentAndUpload() {
        return this.state.stage === 4 && this.state.answers[steps[this.state.stage]] === 'yes'
    }

    showOnlyUpload() {
        return (this.state.stage === 1/* || this.state.stage === 2*/) && this.state.answers[steps[this.state.stage]] === 'yes'
    }

    showTakePhotoButton(currentPhoto) {
        return (
            <div className="row text-center">
                <div className="offset-2 col-8">
                    <div className="form-group text-center">
                        <input type="file" id="photo" accept="image/*" capture="camera" className="mb-4" name="photo" onChange={event =>{this.sendPhoto(event, currentPhoto)}} />
                        <label htmlFor="photo" className={'base-input'}>{!this.getRealPhotos(this.state[photo_steps[this.state.stage].nameStackInState][this.state.photoStep]) ? "TAKE PHOTO" : "REPLACE PHOTO"}</label>
                    </div>
                </div>
            </div>
        )
    }

    goBackPrevStage() {
        addStepLog('Press button goBack in stage: '+steps[this.state.stage]+' on Return vehicle Page');
        let stage = this.state.stage;
        if (stage > 1)
            this.setState({stage: --stage})
    }

    render() {
        let text;
        let comment;

        if (this.state.redirect)
            return <Redirect push to="/send_photo/lock/dashboard" />;

        switch (this.state.stage) {
            case 1:
                text = questions[this.state.stage];
                comment = 'Upload receipt of fuel purchase (optional)';
                break;
            case 2:
/*                text = questions[this.state.stage];
                comment = 'Please upload photo of cargo area';
                break;*/
            case 3:
            case 4:
                text = questions[this.state.stage];
                comment = '';
                break;
        }

        let preview_texts = {
            1: 'Receipt of fuel purchase',
//            2: 'Cargo Area',
            4: 'Damage occurred photo',
        };

        return (<>
            <RedirectOnlyHome />
            <div className={'value-space answer-space'}>
                <div className="row">
                    <div className="offset-2 col-8">
                        <h1 className="gray">{this.state.stage} of {Object.keys(questions).length}</h1>
                    </div>
                </div>
                <div className="row">
                    <div className="offset-2 col-8">
                        <h1 className="mb-4">{text}</h1>
                    </div>
                </div>
                <div className="row">
                    <div className="offset-2 col-8 text-center">
                        <div className="mb-3">
                            <button type="button" className={"base-input white-green mb-4"+this.classNameSelectedAnswer('yes')} onClick={this.handleClickYes.bind(this)}>
                                YES
                            </button>
                            <button type="button" className={"base-input white-red mb-4"+this.classNameSelectedAnswer('no')} onClick={this.handleClickNo.bind(this)}>
                                NO
                            </button>
                        </div>
                    </div>
                </div>
                {
                    this.showOnlyUpload() ? (
                        <div className="row">
                            <div className="offset-2 col-8">
                                <h2 className="gray">{comment}</h2>
                            </div>
                        </div>
                    ) : ('')
                }
                {
                    this.showCommentAndUpload() ?
                    (
                        <div className="row">
                            <div className="offset-2 col-8 text-center form-inputs">
                                <div className="form-group mb-4">
                                    <h2 className="gray">Comment and photo are required</h2>
                                    <textarea name="damage_comment" className="form-control" placeholder="Comment" value={this.state.damage_comment} onChange={this.handleUserInput} />
                                    <div id="damage_comment_errors"/>
                                </div>
                            </div>
                        </div>
                    ) : ('')
                }
                {
                    (this.showOnlyUpload() || this.showCommentAndUpload()) ?
                        // (
                        // <div className="row">
                        //     <div className="col-12 mx-4 pl-4 pr-5 text-left">
                        //         <div className="photo-preview current_step">
                        //             {
                        //                 !this.getPhoto(steps[this.state.stage]) ? (
                        //                     <div className="no-photo"/>
                        //                 ) : (
                        //                     <img src={this.getPhoto(steps[this.state.stage])} />
                        //                 )
                        //             }
                        //             {preview_texts[this.state.stage]}
                        //         </div>
                        //     </div>
                        // </div>
                    // )
                        this.displayPhotos()
                        : ( '' )
                }
                <div className="row text-center">
                    <div className="offset-2 col-8">
                        <div className="row">
                            <div className="col-6">
                                {
                                    this.state.stage !== 1 ?
                                        (
                                            <button type="button"
                                                    className="go-btn go-back"
                                                    onClick={this.goBackPrevStage.bind(this)}/>
                                        ) : ('')
                                }
                            </div>
                            <div className="col-6">
                                {
                                    !this.goNextDisabled() ? (
                                        <button type="button" className={'go-btn go-next mx-auto'+ (this.goNextDisabled() ? ' disabled' : '')} onClick={this.sendAnswer} disabled={this.goNextDisabled()} />
                                    ) : ('')
                                }
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>);
    }
}

const ReturnVehiclePageR = withRouter(ReturnVehiclePage);
export default ReturnVehiclePageR;
